import { jsxs, jsx } from "react/jsx-runtime";
const IconSocialGitHubSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M12.008 2C6.38 2 1.831 6.583 1.831 12.254c0 4.532 2.915 8.369 6.959 9.727.506.102.69-.221.69-.493 0-.237-.016-1.052-.016-1.901-2.831.611-3.42-1.222-3.42-1.222-.456-1.189-1.13-1.494-1.13-1.494-.927-.628.068-.628.068-.628 1.027.068 1.567 1.052 1.567 1.052.91 1.562 2.376 1.12 2.965.85.085-.663.354-1.121.64-1.376-2.257-.238-4.633-1.12-4.633-5.059 0-1.12.404-2.037 1.045-2.75-.102-.254-.455-1.307.1-2.716 0 0 .86-.272 2.798 1.052a9.786 9.786 0 0 1 2.544-.34c.86 0 1.736.12 2.545.34 1.938-1.324 2.797-1.052 2.797-1.052.556 1.409.202 2.462.101 2.716.657.713 1.045 1.63 1.045 2.75 0 3.939-2.376 4.804-4.65 5.06.37.322.69.933.69 1.9 0 1.375-.017 2.479-.017 2.818 0 .272.186.595.691.493a10.246 10.246 0 0 0 6.96-9.727C22.185 6.584 17.62 2 12.007 2Z"
        }
      )
    ]
  }
);
export {
  IconSocialGitHubSvg
};
